import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { api, setAccessToken } from "@/lib/api";
import { useAuth } from "@/lib/AuthContext";
import { toast } from "sonner";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export default function AuthCallback() {
  const { setUser } = useAuth();
  const nav = useNavigate();
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;
    const hash = window.location.hash;
    const m = hash.match(/session_id=([^&]+)/);
    if (!m) {
      nav("/login", { replace: true });
      return;
    }
    const session_id = m[1];
    // Pick up role hint from query (set by login/register Google buttons)
    const params = new URLSearchParams(window.location.search);
    const role = params.get("signup_role") || "patient";
    // Clear hash so refresh doesn't reprocess
    window.history.replaceState(null, "", window.location.pathname);
    (async () => {
      try {
        const { data } = await api.post("/auth/google/session", { session_id, role });
        if (data?.access_token) setAccessToken(data.access_token);
        setUser(data.user);
        toast.success("Signed in with Google");
        nav("/", { replace: true });
      } catch (e) {
        toast.error("Google sign-in failed");
        nav("/login", { replace: true });
      }
    })();
  }, [nav, setUser]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-slate-50">
      <div className="flex flex-col items-center gap-3">
        <div className="h-8 w-8 rounded-full border-2 border-slate-300 border-t-[#339999] animate-spin" />
        <p className="text-sm text-slate-500">Completing sign-in…</p>
      </div>
    </div>
  );
}
